export const parseSearchQuery = (
  query: string,
): {
  resolvedSearchQuery: string;
  tablePatterns: string[];
  schemaPatterns: string[];
  databasePatterns: string[];
} => {
  const searchTerms = query.trim().split(/\s+/);
  const resolvedSearchQuery = searchTerms
    .filter(
      (term) =>
        !(
          term.includes("table:") ||
          term.includes("schema:") ||
          term.includes("database:") ||
          term.includes(".")
        ),
    )
    .join(" ");
  const tablePatterns = searchTerms.filter(
    (term) =>
      term.includes("table:") || (term.includes(".") && !term.includes(":")),
  );
  const schemaPatterns = searchTerms.filter((term) => term.includes("schema:"));
  const databasePatterns = searchTerms.filter((term) =>
    term.includes("database:"),
  );
  return {
    resolvedSearchQuery,
    tablePatterns,
    schemaPatterns,
    databasePatterns,
  };
};

export const parseObjectPattern = (
  pattern: string,
  kind?: "table" | "schema" | "database",
): string[] =>
  (kind ? pattern.replace(`${kind}:`, "") : pattern).split(".").reverse();

export const isQuoted = (query: string): boolean => {
  return query.startsWith('"') && query.endsWith('"');
};

export const constructTableSearchQuery = (params: {
  tablePath: string[];
}): string => {
  return `table:"${params.tablePath.join(".").replaceAll(" ", "_")}"`;
};

export const constructSchemaSearchQuery = (params: {
  schemaPath: string[];
}): string => {
  return `schema:"${params.schemaPath.join(".").replaceAll(" ", "_")}"`;
};
